export default __webpack_public_path__ + "static/media/i-alfinete.ffbe43fa.png";